import { Box, Button, Modal, Typography, useTheme } from "@mui/material";
import { useStyles } from "./styles";
import clsx from "clsx";
import PropTypes from "prop-types";

const ModalPopup = ({
  title,
  message,
  primaryBtnText,
  open,
  secondaryButtonText,
  secondarybtnAction,
  handleClose,
}) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Modal
      className={classes.popup}
      data-testid="popup"
      open={open}
      disableAutoFocus
      onClose={handleClose}
    >
      <Box className={classes.modalWrapper}>
        <Typography
          data-testid="popupTitle"
          className={clsx(classes.text, classes.fontBold)}
          variant="h5"
          align="center"
        >
          {title}
        </Typography>
        <Typography
          data-testid="popupMessage"
          className={clsx(classes.text, classes.multiline)}
          variant="body2"
        >
          {message}
        </Typography>
        <Box className={classes.btnWrapper}>
          <Button
            className={classes.btn}
            data-testid="btn"
            onClick={handleClose}
          >
            {primaryBtnText}
          </Button>
          <Button
            className={classes.btn}
            data-testid="btn2"
            onClick={secondarybtnAction}
          >
            {secondaryButtonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

ModalPopup.propTypes = {
  title: PropTypes.string,
  message: PropTypes.node,
  open: PropTypes.bool,
  primaryBtnText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondarybtnAction: PropTypes.func,
  handleClose: PropTypes.func,
};
export default ModalPopup;
